import React from 'react';
import PropTypes from 'prop-types';
import './dynamicPager.scss'

const DynamicPager = ({ currentPage, totalPages, onPageChange }) => (
  <>
    {totalPages > 1 ? (
      <div className=" w-100 d-flex align-items-center justify-content-between border-top pt-3 dynamic-pager-container ">
        <div className="flex-even d-flex justify-content-start">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            style={{ visibility: `${currentPage > 1 ? "" : "hidden" }`} }
            className="btn btn-sm dynamic-button fit-content"
          >
            Anterior
          </button>
        </div>
        
        <div className="flex-grow-1 d-flex justify-content-center page-number">
          {totalPages > 1 ? (
            <p className="mb-0">
              {currentPage}/{totalPages}
            </p>
          ) : null}
        </div>

        <div className="flex-even d-flex justify-content-end">
          <button
            style={{ visibility: `${currentPage < totalPages ? "" : "hidden" }`} }
            onClick={() => onPageChange(currentPage + 1)}
            className="btn btn-sm dynamic-button fit-content"
          >
            Siguiente
          </button>
        </div>
      </div>
    ) : null}
  </>
);

DynamicPager.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default DynamicPager;